import { ChildBase, ChildGlobalId } from './childUtilityInterfaces';

export enum HoldTypeEnum {
  Convert = 'Convert',
  Create = 'Create',
  Update = 'Update',
}

// https://ciorg.atlassian.net/wiki/spaces/CAD/pages/17386636980/Beneficiary+AM+State+Values
export enum BeneficiaryAvailabilityState {
  /**
   * @description Besneficiary is active in the program, eligible for sponsorship marketing, and has no active commitments.
   */
  Available = 'Available',
  /**
   * @description Besneficiary is held by a Global Partner for the purpose of changing commitments.
   */
  HoldChangeCommitment = 'Change Commitment Hold',
  /**
   * @description Beneficiary is held by a Global Partner for marketing activity.
   */
  HoldConsignment = 'Consignment Hold',
  /**
   * @description Beneficiary is held by a Global Partner temporarily for ecommerce activities
   */
  HoldEcommerce = 'E-Commerce Hold',
  /**
   * @description Beneficiary is held by a Global Partner due to partner canceling sponsorship related to delinquency.
   */
  HoldMassCancel = 'Delinquent Mass Cancel Hold',
  /**
   * @description Beneficiary is held by a Global Partner but is not funded yet.
   */
  HoldNoMoney = 'No Money Hold',
  /**
   * @description Beneficiary is held by a Global Partner related to reinstatement.
   */
  HoldReinstatement = 'Reinstatement Hold',
  /**
   * @description Beneficiary is held by a Global Partner attempting to reserve the child when it becomes available.
   */
  HoldReservation = 'Reservation Hold',
  /**
   * @description Beneficiary is held by a Global Partner for a commitment that was recently canceled.
   */
  HoldSponsorCancel = 'Sponsor Cancel Hold',
  /**
   * @description Beneficiary is held by a Global Partner as it is being marketed to replace a departed sponsorship.
   */
  HoldSubChild = 'Sub Child Hold',
  /**
   * @description Beneficiary has exited the program.
   */
  Inactive = 'Inactive',
  /**
   * @description Beneficiary is active in the program, but is ineligible for sponsorship marketing.
   */
  Ineligible = 'Ineligible',
  /**
   * @description Beneficiary is active in the program and has an active commitment.
   */
  Sponsored = 'Sponsored',
}

export enum BeneficiaryAvailabilityCheckState {
  Available = 'Available',
  Gone = 'Gone',
  Sponsored = 'Sponsored',
  Temporary = 'Temporarily Unavailable',
}

export type Hold = {
  id: string;
  childGlobalId?: ChildGlobalId['globalId'];
  isConsignment?: boolean;
  holdExpiration?: string;
};

export type HoldRequestBase = ChildBase &
  ChildGlobalId & {
    endDate?: string;
    holdId?: string;
    owner?: string;
    sourceCode?: string;
  };

export interface HoldItemConvertPayload {
  holdType: HoldTypeEnum;
}
export interface HoldItemCreatePayload {
  holdType: HoldTypeEnum;
  globalId: ChildGlobalId;
}

export interface HoldCreateUpdateRequest extends HoldRequestBase {
  id?: string;
}

export interface HoldItemPayloadBase {
  body: HoldCreateUpdateRequest;
}

export type HoldItemPayload = HoldItemPayloadBase &
  (HoldItemConvertPayload | HoldItemCreatePayload);

export type HoldUpdateRequest = HoldCreateUpdateRequest &
  ChildGlobalId &
  Omit<ChildBase, 'holdExpirationDate'>;

export interface RemoveHoldResponse {
  success: boolean;
  message: string;
}

export type HoldConvertRequest = ChildBase &
  ChildGlobalId & {
    endDate: string;
    owner: string;
    sourceCode?: string;
  };

export interface HoldReleaseRequest {
  globalId: ChildGlobalId['globalId'];
  holdId: Hold['id'];
}

export interface HoldRequest extends HoldConvertRequest {
  id?: string;
}

export interface HoldCreateRequest extends HoldRequestBase {
  id?: string;
}
